// TODO - Only legacy uses these selectors. Delete this file when legacy is removed
import { createSelector } from 'reselect';

import { store } from '../../../core/state';

const getRestaurantDetailsTemporaryWrapper = (state: WebOrder.State) => {
  const deliveryType = state.location.params.type;
  const vrId = state.location.params.vrid;
  const prId =
    deliveryType === 'collection' ? state.location.params.id : undefined;
  const deliveryLocationId =
    deliveryType === 'delivery' ? state.location.params.id : undefined;

  if (!deliveryType && !vrId && (!prId || !deliveryLocationId)) {
    return undefined;
  }

  return store.selectors.getRestaurantDetails(state, {
    deliveryLocationId,
    deliveryType,
    prId,
    vrId,
  });
};

export const getAvailablePayments = createSelector(
  [
    (state: WebOrder.State) => state.payments.items,
    getRestaurantDetailsTemporaryWrapper,
  ],
  (paymentOptions, restaurant) => {
    if (!restaurant) {
      return [];
    }

    const { AcceptCardOrders, AcceptCashOrders } = restaurant;

    return Object.values(paymentOptions)
      .filter((p) => p.status !== 'error' && p.status !== 'none')
      .filter((p) =>
        AcceptCashOrders ? true : p.PaymentAccountType !== 'CashPaymentAccount',
      )
      .filter((p) =>
        AcceptCardOrders ? true : p.PaymentAccountType !== 'CardPaymentAccount',
      )
      .sort((a, b) => a.displayOrder - b.displayOrder);
  },
);

export const getRemovablePayments = createSelector(
  [(state: WebOrder.State) => state.payments.items],
  (items) =>
    Object.values(items)
      .filter((p) => p.CanRemoveFromCustomerView)
      .sort((a, b) => a.displayOrder - b.displayOrder),
);
